module.exports = __webpack_public_path__ + "static/media/file-sub.51822cd3.svg";